import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { NON_EN_CODES } from "../i18n";

const BASE_URL = "https://immigrationguide.us";
const OG_IMAGE = `${BASE_URL}/og-image.png`;

export function SEOHead({ title, description, image }) {
  const { i18n } = useTranslation();
  const location = useLocation();

  const segments = location.pathname.split("/").filter(Boolean);
  const hasPrefix = NON_EN_CODES.includes(segments[0]);
  const basePath = hasPrefix ? "/" + segments.slice(1).join("/") || "/" : location.pathname;
  const canonical = basePath === "/" ? "" : basePath;
  const fullTitle = title ? `${title} | ImmigrationGuide` : "ImmigrationGuide";
  const pageUrl = `${BASE_URL}${canonical || "/"}`;
  const ogImage = image || OG_IMAGE;

  return (
    <Helmet>
      <html lang={i18n.language} />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={pageUrl} />
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="ImmigrationGuide" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      {/* Hreflang */}
      <link rel="alternate" hrefLang="en" href={`${BASE_URL}${canonical || "/"}`} />
      {NON_EN_CODES.map((lang) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={`${BASE_URL}/${lang}${canonical}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}${canonical || "/"}`} />
    </Helmet>
  );
}
